import React from 'react';
import { IconButton } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const RemoveFavoriteButton = ({ onClick }) => (
  <IconButton
    size="small"
    onClick={e => {
      e.stopPropagation(); // zapobiega propagacji do karty
      onClick();
    }}
    aria-label="Usuń z ulubionych"
    sx={{
      color: '#D2691E',
      backgroundColor: 'rgba(251,146,60,0.18)', // transparent orange
      borderRadius: '50%',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      '&:hover': {
        backgroundColor: 'rgba(251,146,60,0.35)',
      },
      width: 36,
      height: 36,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 0,
    }}
  >
    <DeleteForeverIcon fontSize="small" />
  </IconButton>
);

export default RemoveFavoriteButton;
